import { type ReactNode, useEffect } from 'react';
import { useAuth } from './AuthProvider';
import { currentPath, signInUrl } from './urls';

/**
 * Gate for signed-in-only screens in any app. Signed-out visitors are sent to the hub's sign-in page and
 * returned afterwards (ADR 0009). Cross-app, so it is a full navigation, not a router redirect.
 */
export function RequireAuth({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode }) {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !user) window.location.assign(signInUrl(currentPath(window.location)));
  }, [isLoading, user]);

  if (isLoading || !user) return <>{fallback}</>;
  return <>{children}</>;
}
